// 忽略加载图标的接口
// 服务名::方法
const notLoadIcon = [
    'AdminServices::treeData',
    'Ruyi_AdminWorkbenchServices::allReservationNumber',
];

export default {
    notLoadIcon
}

